import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * The small × inside a text box that empties it in one click — so a mistyped GSTIN, Udyam number
 * or account number is cleared and typed again instead of backspaced character by character.
 * Place inside a `relative` wrapper and give the input right padding (pr-10).
 */
const ClearInputButton = ({ visible, onClear, label = 'Clear', testId }) => {
  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={onClear}
      aria-label={label}
      title={label}
      data-testid={testId}
      className="absolute right-2 top-1/2 -translate-y-1/2 flex h-7 w-7 items-center justify-center rounded-full text-text-secondary hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    >
      <Icon name="X" size={16} />
    </button>
  );
};

export default ClearInputButton;
